import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { Contexto } from 'src/app/asistente-en-linea/models/contexto';
import { DatosEmpresa } from 'src/app/asistente-en-linea/models/DatosEmpresa';
import { FormElements } from 'src/app/asistente-en-linea/models/FormElements';
import { MailService } from '../../services/mail.service';
import { take } from 'rxjs/operators';
import { AlertaConsultenosComponent } from 'src/app/asistente-en-linea/basecomponents/alerta-consultenos/alerta-consultenos.component';
import { MatDialog } from '@angular/material/dialog';
import { VentanaUtils } from 'src/app/asistente-en-linea/utils/ventana.utils';
import { ErrorItem, ErrorTrackingService } from 'src/app/asistente-en-linea/services/error-tracking.service';
import { PopupService } from '../../../../services/popup.service';
import { ContextoUrlService } from '../../../../services/contexto-url.service';
import { LocalStorageService } from '../../../../services/local-storage.service';
import { NavigationContextService } from '../../../../services/navigation-context.service';

declare function eliminarUltimoEventoGoogleAnalytics();
declare function agregarEventoGoogleAnalytics(evento: any);

@Component({
  selector: 'app-formulario-empresa',
  templateUrl: './formulario-empresa.component.html',
  styleUrls: ['./formulario-empresa.component.scss']
})

export class FormularioEmpresaComponent implements OnInit {
  @Input() public ctx: Contexto;
  @Input() public formElements: FormElements;
  @Input() etiqueta_consulta: string = "";
  caracteres_maximo_consulta: number = 600;
  opcionesParaQuienEs: { value: string, texto: string }[] = [];
  esParaMi: boolean = true;
  consulta: string;
  correoUsuario: string;
  nombreEmpresa: string;
  nombre: string;
  nroContribuyente: string;
  nroEmpresa: string;
  attachments: any[] = [];
  correos: string[] = [];
  correo_error_mensaje: string = "";
  paraQuienEs: string = "parami";
  telefono: string = "";
  documento: string = "";
  tipoDocumento: string = "";
  codigoPaisEmisor: string = "";
  temasAsociados: string = "";
  persIdentificador: string = "";
  emailOperativo: string = "";
  codigoTema: string = "";
  descripcionTema: string = "";
  etiquetaNodoArbol: string = "";
  mensajeError: string = "";
  habilitado: boolean = false;
  esAnonimo: boolean = true;
  fromMenu: boolean = false;
  empresas: DatosEmpresa[];
  empresaSeleccionada: DatosEmpresa;
  empresaPreSeleccionada: DatosEmpresa;
  cargandoInformacion: boolean = true;
  onError: boolean = true;
  onSubmitProcess: boolean = false;
  onSuccess: boolean = true;
  errores: ErrorItem[] = [];
  correoUsuarioOpcion: { value: string, texto: string }[];
  correoEmpresasOpcion: { value: string, texto: string }[];
  emailRespuesta: string;
  busquedaManualEmpresa: boolean = false;
  errorValidacion: boolean = false;
  //Mensajes de errores
  consulta_error_mensaje: string = "";
  nombre_error_mensaje: string = "";
  nroContribuyente_error_mensaje: string = "";
  nroEmpresa_error_mensaje: string = "";
  @Output() switchHandlerEmitter = new EventEmitter<Object>();

  constructor(public errorTrackingService: ErrorTrackingService,
    public rest: MailService,
    public dialog: MatDialog,
    private contextoService: ContextoUrlService,
    private navigationContextService: NavigationContextService,
    public window: VentanaUtils) {
    this.errores = [];
    this.fromMenu = false;
  }

  ngOnInit(): void {
    this.empresas = [];
    this.errores = [];
    this.mensajeError = "";
    this.errorValidacion = false;
    this.etiqueta_consulta = this.ctx.etiquetaTema;
    this.opcionesParaQuienEs = [{ value: "parami", texto: "Mis empresas" }, { value: "paraotra", texto: "Otra empresa" }];
    this.cargarInformacion();
  }

  seleccionarEmpresaPreAsignada() {
    if (this.ctx.datosEmpresa) {
      let empresaPreSeleccionada = this.empresas.find(e => e.nroContribuyente == this.ctx.datosEmpresa.nroContribuyente && e.nroEmpresa == this.ctx.datosEmpresa.nroEmpresa);
      if (empresaPreSeleccionada != null) {
        this.seleccionEmpresa(empresaPreSeleccionada);
      }
    }
  }

  async intentarInicializarSesion() {
    //this.ctx.esEntornoAnonimo=false;
    if (!this.ctx.esEntornoAnonimo && this.ctx.fromAnonymous) {
      let url = new URL(this.ctx.urlSitioAutenticar).origin + "/PortalServLinea/rest/inicio/cargarInfoUsuario";
      try {
        const response = await this.rest.obtenerSesionUsuario(url).pipe(take(1)).toPromise();
        console.log(response);
        return true;
      } catch (e) {
        console.error(e);
        return false;
      }
    }
    return true;
  }

  mostrarBotonVolverInicio() {
    if (Object.keys(this.ctx.navigationHistory).length != 0) {
      this.fromMenu = true;
    }
    if (this.ctx.fromAnonymous) {
      this.fromMenu = true;
    }

    if (!this.fromMenu) {
      const asistenteAnterior = this.ctx.obtenerMenuActual();
      if (asistenteAnterior && asistenteAnterior != undefined && asistenteAnterior != '') {
        this.fromMenu = true;
      }
    }
  }

  async cargarInformacion() {
    this.habilitado = false;
    this.cargandoInformacion = true;
    const request = {
      idAsistente: this.ctx.idAsistente,
      datosEmpresaDTO: this.ctx.datosEmpresa,
      idNodo: this.ctx.idNodo ? this.ctx.idNodo : this.ctx.codigoNodoArbol
    }

    const correcto = await this.intentarInicializarSesion();
    if (correcto) {
      this.rest.cargaDatosPersonales(request).subscribe((response) => {

        this.habilitado = response.habilitado;
        this.onError = false;
        this.cargandoInformacion = false;
        if (this.habilitado) {
          this.esAnonimo = typeof response.context.userName == 'undefined';
          // Si viene desde Menu entonces cargo variable fromMenu=true, sino es porque vengo de formulario
          this.mostrarBotonVolverInicio();
          if (!response.tienePermisos) {
            this.mensajeError = response.mensajeValidacion;
          }

          this.etiqueta_consulta = response.nombreFormulario;
          this.ctx.datosEmpresa = response.context.datosEmpresa;
          
          this.ctx.etiquetaTema = response.nombreFormulario;
          if (response.context.datosPersonales) {
            this.ctx.datosPersonales = response.context.datosPersonales;
            if (response.context.datosPersonales.email) {
              this.correos.push(response.context.datosPersonales.email)
            }

            this.telefono = response.context.datosPersonales.telefono;
            this.nombre = response.context.datosPersonales.nombreCompleto;
            this.documento = response.context.datosPersonales.documento;
            this.tipoDocumento = response.context.datosPersonales.tipoDocumento;
            this.codigoPaisEmisor = response.context.datosPersonales.codigoPaisEmisor;
            this.correoUsuario = response.context.datosPersonales.email;
            this.emailRespuesta = response.context.datosPersonales.email;
          }


          this.temasAsociados = response.context.temasAsociados;
          this.persIdentificador = response.context.persIdentificadorStr ? "" + response.context.persIdentificadorStr : undefined;
          this.emailOperativo = response.context.datosEmpresa ? response.context.datosEmpresa.emailOperativo : undefined;
          this.empresas = response.datosEmpresas;

          this.correoUsuarioOpcion = [];
          if (this.correoUsuario && this.correoUsuario != undefined && this.correoUsuario != 'undefined') {
            this.correoUsuarioOpcion.push({ value: this.correoUsuario, texto: this.correoUsuario });
          }


          // Se comprueba si se produce una inyeccion del 'codigoTema' en la URL
          if (this.ctx && this.ctx.codigoTema) {
            // Si el tema viene dado por parametro se instancia ese
            this.codigoTema = this.ctx.codigoTema;
            this.descripcionTema = this.ctx.etiquetaTema;
          }

          if(this.ctx.datosEmpresa && this.ctx.datosEmpresa.nroEmpresa!=undefined && this.empresas.length == 1) {
              this.ctx.datosEmpresa.nombre= response.context.datosEmpresa.denominacionEmpresa;
              this.onEmpresaSeleccionada(this.ctx.datosEmpresa);
          }
          this.busquedaManualEmpresa = response.tieneMasEmpresasHabilitadas;
          //this.busquedaManualEmpresa = true;
          this.cargandoInformacion = false;
          // Eventos para google analytics
          this.registrarEvento();
          //this.seleccionarEmpresaPreAsignada();

        }
      }, (err) => {
        console.log(err);
        this.onError = true;
        this.cargandoInformacion = false;
      });
    }
  }


  /**
   * Retorna al handler desde el cual fue llamado el formulario
   */
  switchAssistantHandler() {
    eliminarUltimoEventoGoogleAnalytics();
    this.ctx.idNodo = undefined;
    this.ctx.codAsistenteError = undefined;
    this.ctx.esReporteError = false;
    if (this.ctx.historialMenus.length > 0) {
      this.ctx.codAsistente = this.ctx.historialMenus[0];
      this.ctx.idMenu = this.ctx.historialMenus[0];
      this.ctx.historialMenus = [];
    }
    if (this.ctx.fromAnonymous) {
      this.window.close.emit();
      if (window.opener) {
        window.opener.postMessage({ accion: 'cerrarPopup' }, '*');
      }
    } else {
      // almacena informacion de navegacion
      this.ctx.historialMenus = [];
      this.ctx.navigationHistory.codAsistente = this.ctx.codAsistente;
      this.ctx.navigationHistory.idServicio = this.ctx.idServicio;
      this.ctx.navigationHistory.idMenu = this.ctx.idMenu;
      this.ctx.navigationHistory.idFormAsociado = this.ctx.idFormAsociado;
      this.navigationContextService.clearAll();
      this.switchHandlerEmitter.emit({ idServicio: this.ctx.idServicio, codAsistente: this.ctx.codAsistente, idMenu: this.ctx.idMenu });
    }

  }

  actualizarAdjuntos(adjuntos: any[]) {
    this.attachments = adjuntos;
  }

  nuevoEmail(correo: string) {
    this.correos.push(correo);
  }

  eliminarMail(correo: string) {
    this.correos = this.correos.filter(c => c != correo);
  }

  actualizarParaQuienEs() {
    this.esParaMi = this.paraQuienEs == "parami";
  }

  cargarAdjuntos(formData: FormData) {
    if (!this.attachments || this.attachments.length === 0) {
      return;
    }

    let i = 1;
    for (const att of this.attachments) {
      if (i > 4) {
        break;
      }

      formData.append(`adjunto${i}`, att);
      formData.append("nombreAdjunto" + i, this.patchEncoding(att.name));
      i++;
    }
  }

  cargarInformacionPersonal(formData: FormData) {
    this.cargarInformacionAutenticado(formData);
    /**if (this.esAnonimo) {
      this.cargarInformacionAnonimo(formData);
    } else {
      this.cargarInformacionAutenticado(formData);
    }**/
  }

  cargarInformacionAutenticado(formData: FormData) {
    if (this.nombre) {
      formData.append("nombreCompleto", this.patchEncoding(this.nombre));
    }
    if (this.documento) {
      formData.append("documento", this.documento);
    }
    if (this.tipoDocumento) {
      formData.append("tipoDocumento", this.tipoDocumento);
    }
    if (this.telefono) {
      formData.append("telefono", this.telefono);
    }
    if (this.codigoPaisEmisor) {
      formData.append("codigoPaisEmisor", this.codigoPaisEmisor);
    }

    if (this.persIdentificador) {
      formData.append("persIdentificadorStr", this.persIdentificador);
    }
  }

  cargarInformacionGeneral(formData: FormData) {
    formData.append("mensaje", this.patchEncoding(this.consulta));
    formData.append("idServicio", this.ctx.idServicio);
    formData.append("codAsistente", this.ctx.codAsistente);
    formData.append("codigoTema", this.codigoTema);
    formData.append("descripcionTema", this.patchEncoding(this.descripcionTema));
    formData.append("idNodo", this.ctx.idNodo);
    formData.append("descripcionNodo", this.patchEncoding(this.etiquetaNodoArbol));
    formData.append("idArbol", this.ctx.idMenu);
    formData.append("idFormAsociado", this.ctx.idFormAsociado);
    if (this.ctx.contexto) {
      formData.append("contexto", this.contextoService.decode(this.ctx.contexto));
    } else {
      formData.append("contexto", this.contextoService.getParentUrlSafely());
    }
    // if (this.correos.length > 0) {
    //   formData.append("correosElectronicos", this.correos.join(','));
    // }

    formData.append("email", this.emailRespuesta);
    const ids = this.navigationContextService.getIds() || [];
    if (ids.length > 0) {
      formData.append("historicoNodos", ids.join(','));
    }

    if (this.esParaMi) {
      let empSel = {
        nroEmpresa: this.empresaSeleccionada.nroEmpresa,
        denominacionEmpresa: this.patchEncoding(this.empresaSeleccionada.nombre),
        codigoAportacion: this.empresaSeleccionada.codigoAportacion,
        nroContribuyente: this.empresaSeleccionada.nroContribuyente,
        //descripcionAportacion: this.patchEncoding("CONSTRUCCIÓN")
        descripcionAportacion: this.patchEncoding(this.empresaSeleccionada.descripcionAportacion)
      };

      formData.append("datosEmpresa", empSel ? JSON.stringify(empSel) : null);
    } else {
      let empSel = {
        nroEmpresa: this.nroEmpresa,
        denominacionEmpresa: this.patchEncoding(this.nombreEmpresa),
        nroContribuyente: this.nroContribuyente
      };

      formData.append("datosEmpresa", empSel ? JSON.stringify(empSel) : null);
    }

  }

  realizarConsulta() {
    if (this.realizarValidaciones()) {
      return;
    }

    this.onSubmitProcess = true;
    let formData: FormData = new FormData();

    // Cargo todos los adjuntos al form data
    this.cargarAdjuntos(formData);

    // Cargo toda la información personal al form data
    this.cargarInformacionPersonal(formData);
    // Cargo la información de la consulta al form data
    this.cargarInformacionGeneral(formData);
    // this.rest.submitEmailFormWithAttachments(formData).subscribe((response) => {
    //   this.ctx.idNodo=undefined;
    //   this.ingresoConsultaOk();
    // });

    this.rest.submitEmailFormWithAttachments(formData).subscribe({
      next: async (response) => {
        this.ctx.idNodo = undefined;
        this.ingresoConsultaOk();
      },
      error: (error) => {
        this.onSubmitProcess = false;
        console.error('Error al enviar formulario', error);
        this.mensajeError = 'En este momento no podemos atenderlo debido a que estamos experimentando algunos problemas técnicos; por favor intente comunicarse con nosotros más tarde.';
        this.errorValidacion = true;
      }
    })

  }

  limpiarErrores() {
    this.errores = [];
    this.errorTrackingService.setErrors([]);
    this.consulta_error_mensaje = "";
    this.nombre_error_mensaje = "";
    this.nroContribuyente_error_mensaje = "";
    this.nroEmpresa_error_mensaje = "";
    this.errorValidacion = false;
    this.mensajeError = "";
  }

  realizarValidaciones() {
    this.limpiarErrores();

    // Validación de consulta
    let consulta_valida = this.consulta && this.consulta.length > 0;
    if (!consulta_valida) {
      this.consulta_error_mensaje = "La consulta no puede estar vacía.";
      this.errores.push({ mensaje: this.consulta_error_mensaje, field: "consulta" });
    }

    if (this.caracteres_maximo_consulta < this.consulta.length) {
      this.consulta_error_mensaje = "La consulta no puede superar el límite (" + this.caracteres_maximo_consulta + ") de caracteres";
      this.errores.push({ mensaje: this.consulta_error_mensaje, field: "consulta" });
    }


    let email_valido = this.emailRespuesta && this.emailRespuesta.length > 0;
    if (!email_valido) {
      this.correo_error_mensaje = 'Debe de seleccionar un correo electrónico.';
      this.errores.push({ mensaje: this.correo_error_mensaje, field: 'correo' });
      this.errorValidacion = true;
      this.mensajeError =this.correo_error_mensaje;
    }

    let empSel = {
      nroEmpresa: this.empresaSeleccionada.nroEmpresa,
      denominacionEmpresa: this.empresaSeleccionada.nombre,
      codigoAportacion: this.empresaSeleccionada.codigoAportacion,
      nroContribuyente: this.empresaSeleccionada.nroContribuyente,
      descripcionAportacion: this.empresaSeleccionada.descripcionAportacion
    };

    // Validación de nroEmpresa
    let nroEmpresa = empSel.nroEmpresa && empSel.nroEmpresa.length > 0;
    if (!nroEmpresa) {
      this.nroEmpresa_error_mensaje = "El número de empresa ingresado no es válido.";
      this.errores.push({ mensaje: this.nroEmpresa_error_mensaje, field: "nroEmpresa" });
      this.errorValidacion = true;
      this.mensajeError =this.nroEmpresa_error_mensaje;
    }

    this.asignarErrores();

    return this.errores.length > 0;
  }

  asignarErrores() {
    this.errorTrackingService.setErrors(this.errores);
    if (this.errores.length > 0) {
      setTimeout(() => {
        this.focoElemento("existe-error");
      }, 500)
    }
  }

  focoElemento(elementoId: string) {
    const element = document.getElementById(elementoId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }

  ingresoConsultaOk() {
    this.onSubmitProcess = false;
    this.onSuccess = true;
    const dialogRef = this.dialog.open(AlertaConsultenosComponent, { disableClose: true });
    dialogRef.afterClosed().subscribe(result => {
      if (!result) return;

      if (result === AlertaConsultenosComponent.nueva_consulta) {
        this.nuevaConsulta();
      }
      else if (result === AlertaConsultenosComponent.cerrar_asistente) {
        if (this.ctx.refresh) {
          this.nuevaConsulta();
          this.switchAssistantHandler();
        } else {
          this.window.close.emit();
          if (window.opener) {
            window.opener.postMessage({ accion: 'cerrarPopup' }, '*');
          }
        }
      }
    })
  }


  nuevaConsulta() {
    this.ctx.codAsistenteError = undefined;
    this.ctx.esReporteError = false;
    this.consulta = "";
    this.paraQuienEs = "parami";
    this.actualizarParaQuienEs();
    this.limpiarValores();
    // this.cargarInformacion();
    this.onSuccess = false;
  }

  limpiarValores() {
    if (this.esAnonimo) {
      this.nombreEmpresa = "";
      this.nroContribuyente = "";
      this.nroEmpresa = "";
    }
    this.consulta = "";
  }

  seleccionEmpresa(empresaSeleccionada: DatosEmpresa) {
    this.empresaSeleccionada = empresaSeleccionada;
    //debugger
    console.log("Empresa seleccionada: " + this.empresaSeleccionada)
  }

  /**
  * Metodo auxiliar que convierte algunos caracteres especiales por limintacion actual 
  * que tenemos para enviar datos 
  * @param valor 
  * @returns 
  */
  private patchEncoding(valor: string): string {
    if (valor) {
      let resultado = valor.replace(/ñ/g, '&ntilde;').replace(/Ñ/g, '&Ntilde;');
      resultado = resultado.replace(/á/g, '&aacute;').replace(/Á/g, '&Aacute;');
      resultado = resultado.replace(/é/g, '&eacute;').replace(/É/g, '&Eacute;');
      resultado = resultado.replace(/í/g, '&iacute;').replace(/Í/g, '&Iacute;');
      resultado = resultado.replace(/ó/g, '&oacute;').replace(/Ó/g, '&Oacute;');
      resultado = resultado.replace(/ú/g, '&uacute;').replace(/Ú/g, '&Uacute;');
      resultado = resultado.replace(/ü/g, '&uuml;').replace(/Ü/g, '&Uuml;');
      resultado = resultado.replace(/¿/g, '&iquest;');
      resultado = resultado.replace(/!/g, '&#33;');
      resultado = resultado.replace(/¡/g, '&#161;');
      return resultado;

    } else {
      return valor
    }
  }



  onEmpresaSeleccionada(empresa: DatosEmpresa) {
    this.empresaSeleccionada = null;
    this.correoEmpresasOpcion = [];
    this.mensajeError = "";
    this.errorValidacion = false;
    if (empresa != null) {
      //empresa.tienePermisos = false;
      if (empresa.tienePermisos) {
        this.empresaSeleccionada = empresa;
        //empresa.emailOperativo=undefined;
        if (empresa.emailOperativo && empresa.emailOperativo != undefined && empresa.emailOperativo != 'undefined' && this.emailRespuesta != empresa.emailOperativo) {
          this.correoEmpresasOpcion.push({ value: empresa.emailOperativo, texto: empresa.emailOperativo });
          //reseteo el mail seleccionado al del usuario
          this.emailRespuesta = this.correoUsuario;
        }
        if((this.correoUsuario === undefined || this.correoUsuario === 'undefined' ) && (empresa.emailOperativo === undefined || empresa.emailOperativo === 'undefined')) {
          this.mensajeError = 'En este momento no podemos atenderlo debido a que estamos experimentando algunos problemas técnicos; por favor intente comunicarse con nosotros más tarde.';
          this.errorValidacion = true;
        }
      } else {
        this.errorValidacion = true;
        this.mensajeError = "El usuario no tiene los permisos para realizar la consulta.";
      }
    }
  }

  registrarEvento() {
    let evento = {
      codAsistente: this.ctx.codAsistente,
      descServicio: this.ctx.descServicio,
      idAsistente: this.ctx.idAsistente,
      idServicio: this.ctx.idServicio,
      idNodo: this.ctx.idNodo,
      nodoNombre: this.ctx.etiquetaTema
    }
    agregarEventoGoogleAnalytics(evento);
  }
}
